<button [class]="class" [matTooltip]="toolTip" mat-icon-button matSuffix type="button">
    <mat-icon>download</mat-icon>
</button>